import { useLanguage } from '../language-context.js';
import content from '../content.js';

const Footer = () => {
  const { lang } = useLanguage();
  const t = content[lang].footer;
  const cvHref = content[lang].cvHref;
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" id="contact">
      <h2>{t.heading}</h2>
      <ul className="footer-links">
        {t.links.map((link) => (
          <li key={link.href}><a href={link.href} target="_blank" rel="noopener noreferrer">{link.label}</a></li>
        ))}
        <li><a href={cvHref} target="_blank" rel="noopener noreferrer">{t.cvLabel}</a></li>
      </ul>
      <p className="footer-copyright">&copy; {year} Rodrigo Quaresma</p>
    </footer>
  );
}

export default Footer;
